import {Customer} from '@/models/Customer'
import {Model} from '@/models/Model'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import {Shipping} from '@/models/Shipping'
import {Timeline} from '@/models/Timeline'
import {TransportRoute} from '@/models/TransportRoute'
import {Truck} from '@/models/Truck'
import Helper from '../services/Helper.js'


export const RouteConst = Object.freeze({
    STATUS_IMPORT: 1,
    STATUS_DRAFT: 2,
    STATUS_RESERVE: 3,
    STATUS_APPROVED_PENDING_SYNC: 5,
    STATUS_SYNCED_PENDING_ACTIVE: 6,
    STATUS_DO_CONFIRMED_WAIT_STOCK: 7,
    STATUS_ISSUED_WAIT_LOAD: 8,
    STATUS_ON_DELIVERY: 9,
    STATUS_RETURN: 11,
    STATUS_OVERDUE: 12,

    STATUS_REJECT: 99,


    map(status: number): string {
        switch (status) {
            case RouteConst.STATUS_IMPORT:
                return 'แก้ไข'
            case RouteConst.STATUS_DRAFT:
                return 'ดราฟ'
            case RouteConst.STATUS_RESERVE:
                return 'จอง'
            case RouteConst.STATUS_APPROVED_PENDING_SYNC:
                return 'ส่งเข้า ERP'
            case RouteConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'รออนุมัติ'
            case RouteConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'อนุมัติ'
            case RouteConst.STATUS_ISSUED_WAIT_LOAD:
                return 'รอขนขึ้นรถ'
            case RouteConst.STATUS_ON_DELIVERY:
                return 'กำลังขนส่ง'
            case RouteConst.STATUS_RETURN:
                return 'เสร็จ'
            case RouteConst.STATUS_REJECT:
                return 'ยกเลิก'
            //รอจัดทริป
            //กำลังขนส่ง
            //
        }
        // debugger
        return 'ไม่ระบุ[' + status + ']'
    },

    mapShort(status: number): string {
        switch (status) {
            case RouteConst.STATUS_IMPORT:
                return 'แก้ไข'
            case RouteConst.STATUS_DRAFT:
                return 'ดราฟ'
            case RouteConst.STATUS_RESERVE:
                return 'จอง'
            case RouteConst.STATUS_APPROVED_PENDING_SYNC:
                return 'ส่งเข้า ERP'
            case RouteConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'รออนุมัติ'
            case RouteConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'อนุมัติ'
            case RouteConst.STATUS_ISSUED_WAIT_LOAD:
                return 'รอขึ้น'
            case RouteConst.STATUS_ON_DELIVERY:
                return 'ส่ง'
            case RouteConst.STATUS_RETURN:
                return 'เสร็จ'
            case RouteConst.STATUS_REJECT:
                return 'ยกเลิก'
            //รอจัดทริป
            //กำลังขนส่ง
            //
        }
        // debugger
        return 'ไม่ระบุ[' + status + ']'
    },

    color(status: number): string {
        switch (parseInt(`${status}`)) {
            case RouteConst.STATUS_IMPORT:
                return 'teal'
            case RouteConst.STATUS_DRAFT:
                return 'grey lighten-1'
            case RouteConst.STATUS_RESERVE:
                return 'amber'
            //
            //   return 'grey lighten-1'
            case RouteConst.STATUS_APPROVED_PENDING_SYNC:
                return 'grey lighten-1'
            case RouteConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'teal'
            case RouteConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'lime'
            case RouteConst.STATUS_ISSUED_WAIT_LOAD:
                return 'lime'
            case RouteConst.STATUS_ON_DELIVERY:
                return 'light-green'
            case RouteConst.STATUS_RETURN:
                return 'blue-grey'
            case RouteConst.STATUS_REJECT:
                return 'red'

        }
        // debugger
        return ''
    }
})


export class Progress {
    public status: string = 'DONE'
    public percent: number = 0
    public text: string = ''
    public level: string = 'INFO'
}

export class Route extends Model {
    declare id: number | null
    created_at: Date | null
    updated_at: Date | null
    load_at: Date | null
    start_at: Date | null
    end_at: Date | null

    first_deadline_at: Date | null

    total_cost: number | null
    total_worth: number | null
    accommodation_cost: number | null
    driver_cost: number | null
    fuel_cost: number | null
    motor_cost: number | null
    ot_cost: number | null
    status: number | null

    total_volume_cbm: number | null
    total_weight_kg: number | null
    total_distance: number | null

    results: RouteResult | null = new RouteResult()

    customer: Customer | null

    mode: string | null

    truck: Truck | null
    truck_id: number | null

    shipping: Shipping | null

    transport_route: TransportRoute | null

    docbook: string | null

    timeline: Timeline[]

    export_drop: any = {}

    districts: any = {}

    still_pending: boolean = false

    recal_path: boolean | null

    cache_provinces: string | null

    getSkipField(): string[] {
        return ['timeline']
    }

    getResourceURL(): string {
        return Helper.setting.route.getResourceAPI
    }

    async ConfirmRoute(): Promise<Route> {
        // debugger
        return await this.SetStatus(RouteConst.STATUS_DRAFT)
    }

    async ImportDraft(): Promise<Route> {
        // debugger
        return await this.SetStatus(RouteConst.STATUS_IMPORT)
    }

    async SetStatus(status: number): Promise<Route> {
        // debugger
        this.status = status
        return await this.save<Route>()
    }

}

export class DataRoutesArray extends DataArray {

    declare data: Route[]
    filter: FilterRoute = new FilterRoute()
}


export class FilterRoute {
    price_group: FilterSet = new FilterSet()
}


export class DataRoute extends DataResource {

    declare data: Route

}

export class RouteResult {

    optimized: OptimizedAction[] = []

}

export class OptimizedAction {

    action: string = ''

}
